export default __webpack_public_path__ + "static/media/AdBugs_05.e6be76e5.png";